import React, { useState, useEffect } from 'react';
import {
  Backdrop,
  Box,
  Modal,
  Fade,
  TextField,
  Button,
  Typography,
  Stack,
  IconButton,
  InputAdornment
} from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import axios from 'axios';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 480,
  bgcolor: 'background.paper',
  borderRadius: 2,
  boxShadow: 24,
  p: 4,
};

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:8000';

const LoginModal = ({ open, onLoginSuccess }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    if (!open) {
      setUsername('');
      setPassword('');
      setError('');
    }
  }, [open]);

  const handleLogin = async () => {
    try {
      const formData = new URLSearchParams();
      formData.append("username", username);
      formData.append("password", password);

      const res = await axios.post(`${API_BASE}/login`, formData, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      });

      const token = res.data?.access_token;
      if (!token) {
        setError("Token not returned by server.");
        return;
      }

      localStorage.setItem("token", token);
      onLoginSuccess();
    } catch (err) {
      setError("Incorrect username or password.");
    }
  };

  const handleRegister = () => {
    alert('Registration not yet implemented.');
  };

  return (
    <Modal
      open={open}
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      slotProps={{
        backdrop: {
          timeout: 500,
        },
      }}
    >
      <Fade in={open}>
        <Box sx={style}>
          <Typography variant="h6" mb={2} fontWeight={600}>
            You have to log in to <span style={{ color: '#1976d2' }}>save</span> your analysis results!
          </Typography>

          <Stack spacing={2}>
            <TextField
              label="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              fullWidth
            />
            <TextField
              label="Password"
              type={showPassword ? 'text' : 'password'}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              fullWidth
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="Show/Hide password"
                      onClick={() => setShowPassword(!showPassword)}
                      edge="end"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                )
              }}
            />
            {error && (
              <Typography variant="body2" color="error">
                {error}
              </Typography>
            )}
            <Stack direction="row" spacing={2} justifyContent="space-between">
              <Button variant="outlined" onClick={() => window.location.reload()}>
                Cancel
              </Button>
              <Button variant="contained" onClick={handleLogin}>
                Log In
              </Button>
              <Button variant="text" onClick={handleRegister}>
                Register
              </Button>
            </Stack>
          </Stack>
        </Box>
      </Fade>
    </Modal>
  );
};

export default LoginModal;